<template>
  <div v-if="data && paymentData.data?.length">
    <div :class="$style.paymentBlockMobile">
      <div :class="$style.tabButtonBlock">
        <BitTabButton
          v-for="tab in namesTabs"
          :key="tab.text"
          :active="selectedTab === tab.value"
          :class="$style.tabButton"
          @click="changeSelectTab(tab.value)"
        >
          {{ tab.text }}
        </BitTabButton>
      </div>
      <InfoPagePaymentBlockTable
        :class="$style.tab"
        :data="data"
        :payments="paymentData.data"
        :deposit="paymentData.deposit"
      />
    </div>
    <div :class="$style.paymentBlockDesktop">
      <div :class="$style.tabButtonBlock">
        <BitTabButton
          v-for="tab in namesTabs"
          :key="tab.text"
          :active="selectedTab === tab.value"
          :class="$style.tabButton"
          @click="changeSelectTab(tab.value)"
        >
          {{ tab.text }}
        </BitTabButton>
      </div>
      <InfoPagePaymentBlockTable
        v-show="selectedTab == EPaymentsType.deposit"
        :data="data"
        :payments="storePaymentsData.deposit"
        :deposit="true"
        gtm-action="deposit_click"
        gtm-category="deposit"
      />
      <InfoPagePaymentBlockTable
        v-show="selectedTab == EPaymentsType.withdrawal"
        :data="data"
        :payments="storePaymentsData.withdrawal"
        :deposit="false"
        gtm-action="withdrawal_click"
        gtm-category="withdrawal"
      />
    </div>
  </div>
  <PaymentBlockSkeleton v-else />
</template>

<script lang="ts" setup>
import { BitTabButton } from '@bit/ui-kit';
import { computed, onBeforeMount, ref } from 'vue';
import InfoPagePaymentBlockTable from '~/components/infoPage/paymentBlockTable.vue';
import { useStorePaymentsData } from '~/stores/strapi/paymentsData';
import { EPaymentsType } from '~/types/payments';
import PaymentBlockSkeleton from './paymentBlockSkeleton.vue';
import type { ComponentInfoPageBlocksPaymentsBlock } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksPaymentsBlock>,
    required: true,
  },
});

const storePaymentsData = useStorePaymentsData();

const selectedTab = ref('' as EPaymentsType);

const namesTabs = computed(() => [
  { text: props.data.depositHeaderTitle, value: EPaymentsType.deposit },
  { text: props.data.withdrawalHeaderTitle, value: EPaymentsType.withdrawal },
]);

const paymentData = computed(() => {
  if (selectedTab.value === namesTabs.value[0].value) {
    return { data: storePaymentsData.deposit, deposit: true };
  } else {
    return { data: storePaymentsData.withdrawal, deposit: false };
  }
});

const changeSelectTab = (tabName: EPaymentsType) => {
  switch (tabName) {
    case EPaymentsType.deposit:
      selectedTab.value = EPaymentsType.deposit;
      break;
    case EPaymentsType.withdrawal:
      selectedTab.value = EPaymentsType.withdrawal;
      break;
    default:
      selectedTab.value = EPaymentsType.deposit;
      break;
  }
};

onBeforeMount(async () => {
  selectedTab.value = EPaymentsType.deposit;
  await storePaymentsData.loadPaymentsData();
});
</script>

<style lang="scss" module src="./paymentBlock.scss"></style>
